"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var VerificationSuccessful_1 = __importDefault(require("./VerificationSuccessful"));
var VerifyByCode_1 = __importDefault(require("./VerifyByCode"));
var VerifyPhoneModal = function (_a) {
    var opened = _a.opened, onClose = _a.onClose;
    var _b = (0, react_1.useState)(0), step = _b[0], setStep = _b[1];
    var restoreStepAndClose = (0, react_1.useCallback)(function () {
        setStep(0);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    if (!opened) {
        return null;
    }
    return (react_1.default.createElement(ui_components_1.Modal, { width: "480px", height: "auto", padding: "0", onClose: restoreStepAndClose, saveSize: true, closeOnlyOnCross: true, overflowY: "visible" },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content }, step === 0 ? (react_1.default.createElement(VerifyByCode_1.default, { setNextStep: function () {
                setStep(1);
            } })) : (react_1.default.createElement(VerificationSuccessful_1.default, { onClose: restoreStepAndClose, setPrevStep: function () {
                setStep(0);
            } })))));
};
exports.default = VerifyPhoneModal;
